import { render, staticRenderFns } from "./formSysPermCodeDetail.vue?vue&type=template&id=292375b7&"
import script from "./formSysPermCodeDetail.vue?vue&type=script&lang=js&"
export * from "./formSysPermCodeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports